<template>
  <hm-content title>
    <div class="flex mb20">
      <div class="flex">
        <el-button type="primary" size="small" @click="openAddDialogVisible"
          >新增项目类型</el-button
        >
      </div>
    </div>
    <div>
      <el-table
        stripe
        border
        :data="serviceList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serviceType"
          label="服务类型"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="图标默认/选中"
        >
          <template slot-scope="scope">
            <!-- <el-image
              class="mr10 memberImage"
              :src="scope.row.serviceIcon"
            ></el-image> -->
            <el-image
              class="mr10 memberImage"
              :src="scope.row.serviceIcon"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="serviceTypeSort"
          label="分类序号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serviceCode"
          label="编码"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="serviceRemark"
          show-overflow-tooltip
          label="备注"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.enabledState === 'yes'" class="success"
              >显示</span
            >
            <span v-if="scope.row.enabledState === 'no'" class="orange"
              >不显示</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="操作"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                type="text"
                class="blue"
                size="small"
                @click="edit(scope.row)"
                >编辑</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChanges"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>

      <el-dialog
        :title="projectClassification"
        :close-on-click-modal="false"
        :visible.sync="AddDialogVisible"
        :before-close="cancel"
      >
        <div class="text-left">
          <el-form
            :model="serviceForm"
            ref="serviceForm"
            label-width="200px"
            :rules="rules"
          >
            <el-form-item label="项目分类" prop="serviceType">
              <el-input
                clearable
                maxlength="10"
                @mousewheel.prevent.native
                v-model.trim="serviceForm.serviceType"
                placeholder="请输入服务类型，不要超过10个字"
                size="small"
                class="ipt mr10"
                style="width: 340px"
              ></el-input>
            </el-form-item>

            <el-form-item label="分类序号" prop="serviceTypeSort">
              <el-input
                clearable
                @mousewheel.prevent.native
                v-model.number="serviceForm.serviceTypeSort"
                placeholder="序号小的排在前面，应用显示的位置"
                size="small"
                class="ipt mr10"
                style="width: 340px"
              ></el-input>
            </el-form-item>

            <el-form-item label="编码">
              <el-input
                clearable
                maxlength="8"
                @mousewheel.prevent.native
                v-model.trim="serviceForm.serviceCode"
                placeholder="最长8个字符，英文+数字，分类+编码，组成分类编码"
                size="small"
                class="ipt mr10"
                style="width: 340px"
              ></el-input>
            </el-form-item>



            <!-- <el-form-item label="默认图标:" prop="serviceIcon"> -->
            <el-form-item label="分类图标:">
              
              <!-- <el-upload
                class="upload flex"
                ref="eluploadMainPic"
                :limit="1"
                :width="80"
                :height="80"
                drag
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onSuccess="uploadMainPicSucc"
                :beforeUpload="beforeUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                v-if="!serviceForm.serviceIcon"
              >
                <i class="el-icon-plus"></i>
                <div class="el-upload__text">上传默认图标</div>
                <div
                  class="el-upload__tip"
                  slot="tip"
                  v-if="!serviceForm.serviceIcon"
                >
                  <div class="ml10">
                    上传图片注意：
                    <div>1.需要上传默认状态的图标</div>
                    <div>2.图标建议尺寸80x80像素</div>
                  </div>
                </div>
              </el-upload>
              <div class="priview" v-if="serviceForm.serviceIcon">
                <img :src="serviceForm.serviceIcon" alt="默认图标" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemove">删除</el-button>
                </div>
              </div> -->



              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                v-if="show"
                noCircle
                noSquare
                :width="80"
                :height="80"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mall' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
          
              <el-button
                type="primary"
                size="small"
                v-show="!serviceForm.serviceIcon"
                @click="toggleShow"
                >上传</el-button
              >
              <span class="form-tip"
                >图片尺寸建议80x80（最多上传一张）</span
              >
              <div class="priview" v-if="serviceForm.serviceIcon">
                <img :src="serviceForm.serviceIcon" alt="主图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="toggleShow">更换</el-button>
                </div>
              </div>




            </el-form-item>


            <el-form-item label="启用状态:" prop="enabledState">
              <el-switch
                v-model="serviceForm.enabledState"
                active-text="开启"
                inactive-text="关闭"
                active-color="#13ce66"
                active-value="yes"
                inactive-value="no"
              ></el-switch>
            </el-form-item>
            <el-form-item label="服务规则说明:" prop="serviceRemark">
              <el-input
                maxlength="200"
                type="textarea"
                v-model="serviceForm.serviceRemark"
                placeholder="请输入服务规则说明"
                show-word-limit
              ></el-input>
            </el-form-item>
            <div class="flex flex-center">
              <el-button
                type="primary"
                size="small"
                @click="saveService('serviceForm', 'save')"
                v-if="isbtnSave"
                >提交</el-button
              >
              <el-button
                type="primary"
                size="small"
                @click="saveService('serviceForm', 'edit')"
                v-if="!isbtnSave"
                >保存</el-button
              >
              <el-button size="small" @click="cancel"
                >取消</el-button
              >
            </div>
          </el-form>
        </div>
      </el-dialog>
      
    </div>
  </hm-content>
</template>

<script>
import myUpload from "vue-image-crop-upload";
export default {
  components: {myUpload},
  data() {
    return {
      projectClassification:"新增项目分类",
      tempType: "",
      myCurrentPage: 1,
      myPageSize: 10,
      currentPage: 1,
      pageSize: 10,
      ListTotal:0,
      total:0,
      show: false,
      activeName: "my",
      serviceList: [],
      data: [],
      groupList: [],
      groupListTotal: 0,
      myTotal: 0,
      tempTypeList: [],
      serviceForm: {
        id: "",
        serviceCode: "",
        serviceTypeSort:'',
        serviceType:'',
        serviceIcon: "https://redpackagecdn.hemiao100.com/static/fuwu/%E9%BB%98%E8%AE%A4%E5%9B%BE%E6%A0%87.png",
        serviceRemark: "",
        enabledState: "yes",
      },
      AddDialogVisible: false,
      uploadShow: true,
      uploadShow2: true,
      isSaving: false,
      isbtnSave: true,
      rules: {
        serviceType: [
          { required: true, message: "请输入服务类型", trigger: "blur" },
        ],
        // serviceIcon: [
        //   { required: true, message: "请上传默认图标", trigger: "change" },
        // ],
        serviceTypeSort: [
          { required: true, message: '分类不能为空'},
          { type: 'number', message: '分类必须为数字值'}
        ],
        // serviceIconChecked: [
        //   { required: true, message: "请上传选中图标", trigger: "change" },
        // ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryServiceRestorationTypeList();
  },
  mounted() {},
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.serviceForm.serviceIcon = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    openAddDialogVisible() {
      this.projectClassification = "新增项目分类";
      this.serviceForm = {
        id: "",
        serviceCode: "",
        serviceTypeSort:'',
        serviceType:'',
        serviceIcon: "https://redpackagecdn.hemiao100.com/static/fuwu/%E9%BB%98%E8%AE%A4%E5%9B%BE%E6%A0%87.png",
        serviceRemark: "",
        enabledState: "yes",
      };
      this.isbtnSave = true;
      this.AddDialogVisible = true;
    },
    // beforeUpload(file) {
    //   const extension =
    //     file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
    //       "jpg" ||
    //     file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
    //   const extension2 =
    //     file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
    //     "jpeg";
    //   const extension3 =
    //     file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
    //   const extension4 =
    //     file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
    //   // file.size单位为b，除以1024得到kb
    //   const limitSize = file.size / 1024 <= 1020;
    //   if (!extension && !extension2 && !extension3 && !extension4) {
    //     this.$message({
    //       message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
    //       type: "warning",
    //     });
    //   }
    //   if (!limitSize) {
    //     this.$message({
    //       message: "上传模板大小不能超过 1M!",
    //       type: "warning",
    //     });
    //   }
    //   return (extension || extension2 || extension3 || extension4) && limitSize;
    // },
    // 添加
    async saveService(formName, type) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const params = this.serviceForm;
        const regex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9]+$/;
        //params.serviceCode 最长8个字符，英文+数字，分类+编码，组成分类编码
        if(params.serviceCode){
          if (!regex.test(params.serviceCode) || params.serviceCode.length > 8 || params.serviceCode.length < 0) {
            this.$message({
              message: "编码只能是1-8位英文或数字，且不能包含特殊字符",
              type: "warning",
            });
            return;
          }
        }


        let src = "";
        if (type === "save") {
          src = "saveServiceRestorationType";
        } else if (type === "edit") {
          src = "editServiceRestorationType";
        }
        const { code } = await this.$store.dispatch(src, params);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success",
          });
          this.AddDialogVisible = false;
          this.queryServiceRestorationTypeList();
        }

        
      }else {
        this.$message({
          message: "请检查输入项是否正确",
          type: "warning",
        });
      }
    },
    // 列表
    async queryServiceRestorationTypeList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };

      const { result } = await this.$store.dispatch(
        "queryServiceRestorationTypePageList",
        params
      );
      if (result) {
        const { records, total } = result;
        this.serviceList = records;
        this.total = total;
      }
    },
    edit(row) {
      this.projectClassification = "编辑项目分类";
      row.serviceTypeSort = Number(row.serviceTypeSort);
      this.serviceForm = row;
      this.isbtnSave = false;
      this.AddDialogVisible = true;
    },
    cancel(){
      this.AddDialogVisible = false;
      this.queryServiceRestorationTypeList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryServiceRestorationTypeList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryServiceRestorationTypeList();
    },
    handleSizeChanges(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryServiceRestorationTypeList();
    },
  },
};
</script>
<style lang="scss" scoped>
.memberImage {
  width: 34px;
  height: 34px;
}
.upload {
  width: 400px;
  /deep/ .el-icon-plus {
    margin-top: 40px;
  }
  /deep/ .el-upload-dragger {
    width: 106px;
    height: 106px;
  }
  /deep/ .el-upload__tip {
    width: 300px;
    line-height: 30px;
  }
}
.priview {
  position: relative;
  width: 106px;
  height: 106px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .video {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }  
}
</style>
<style lang="scss">
    .el-tooltip__popper{max-width:15%}
</style>
